import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Container,
  Card,
  CardContent,
  Alert,
} from "@mui/material";
import Logo from "../../../images/logo/Ezcarrentals-logo.png";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { auth } from "../../../lib/firebase";

const LoginForm = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    setErrorMessage("");
    signInWithEmailAndPassword(auth, username, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (user) {
          navigate("/admin-dashboard/upload-vehicle-details");
        }
      })
      .catch(() => {
        setErrorMessage("Failed to login. Please check your credentials.");
      });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate("/admin-dashboard/upload-vehicle-details");
      }
    });

    return unsubscribe;
  }, [navigate]);

  return (
    <Box sx={{ bgcolor: "#333333" }}>
      <Container component='main' maxWidth='md'>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Card sx={{ position: "relative", maxWidth: 400, margin: "auto" }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  m: 2,
                }}
              >
                <img src={Logo} alt='EZ Car Rentals Logo' />
              </Box>

              <Typography variant='h6'>Login</Typography>
              {errorMessage && (
                <Alert severity='error' sx={{ mt: 2 }}>
                  {errorMessage}
                </Alert>
              )}
              <form onSubmit={handleLogin}>
                <TextField
                  label='Username'
                  variant='outlined'
                  margin='normal'
                  fullWidth
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  InputProps={{
                    style: { fontSize: "16px" },
                  }}
                />
                <TextField
                  label='Password'
                  variant='outlined'
                  margin='normal'
                  fullWidth
                  type='password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    style: { fontSize: "16px" },
                  }}
                />
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  fullWidth
                  sx={{
                    fontSize: "16px",
                    bgcolor: "#333333",
                    mt: 3,
                    mb: 3,
                    p: 1,
                  }}
                >
                  Login
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </Container>
    </Box>
  );
};

export default LoginForm;
